/* eslint-disable import/no-default-export */
import common from './common'
import errors from './errors'

export default {
  common,
  errors
}
